import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_FETCH_ORDERS_DATA_BEGIN,
  REPORTS_FETCH_ORDERS_DATA_SUCCESS,
  REPORTS_FETCH_ORDERS_DATA_FAILURE,
  REPORTS_FETCH_ORDERS_DATA_DISMISS_ERROR,
} from './constants';

export function fetchOrdersData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_ORDERS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/getOrdersReport`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_ORDERS_DATA_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              summary: res.data && res.data.summary,
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_ORDERS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchOrdersDataError() {
  return {
    type: REPORTS_FETCH_ORDERS_DATA_DISMISS_ERROR,
  };
}

export function useFetchOrdersData() {
  const dispatch = useDispatch();

  const { reportsOrderData, reportsOrderTotals, orderSummary,fetchOrdersDataPending, fetchOrdersDataError } = useSelector(
    state => ({
      reportsOrderData: state.reports.reportsOrderData,
      reportsOrderTotals: state.reports.reportsOrderTotals,
      orderSummary: state.reports.orderSummary,
      fetchOrdersDataPending: state.reports.fetchOrdersDataPending,
      fetchOrdersDataError: state.reports.fetchOrdersDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchOrdersData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchOrdersDataError());
  }, [dispatch]);

  return {
    reportsOrderData,
    reportsOrderTotals,
    orderSummary,
    fetchOrdersData: boundAction,
    fetchOrdersDataPending,
    fetchOrdersDataError,
    dismissFetchOrdersDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_ORDERS_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchOrdersDataPending: true,
        fetchOrdersDataError: null,
      };

    case REPORTS_FETCH_ORDERS_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsOrderData: action.data.data,
        reportsOrderTotals: action.data.totals,
        orderSummary:action.data.summary,
        fetchOrdersDataPending: false,
        fetchOrdersDataError: null,
      };

    case REPORTS_FETCH_ORDERS_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchOrdersDataPending: false,
        fetchOrdersDataError: action.data.error,
      };

    case REPORTS_FETCH_ORDERS_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchOrdersDataError: null,
      };

    default:
      return state;
  }
}
